import { options, options2 } from './options';
import { CardColumn, CardRow, BeatHorizontalCardCustom } from './styles';

export const BeatHorizontalCardExample = () => (
  <CardColumn>
    <CardRow>
      {options.map((option) => {
        return <BeatHorizontalCardCustom
          textBody={option.textBody}
          footerContents={option.footerContents}
        />

      })}
    </CardRow>
    <CardRow>
      {options2.map((option) => {
        return <BeatHorizontalCardCustom
          textBody={option.textBody}
          footerContents={option.footerContents}
        />

      })}
    </CardRow>
  </CardColumn>

);
